import { getEnvVars } from '@/../config/get-env-vars';
import { version } from '../version';

window.global ||= window;

const envVars = getEnvVars();
export const env = {
  VITE_ENV: envVars.VITE_ENV,
  VITE_AZURE_ENV: envVars.VITE_AZURE_ENV,
  VITE_PLATFORM_REST_ENDPOINT: envVars.VITE_PLATFORM_REST_ENDPOINT,
  VITE_X_API_KEY: envVars.VITE_X_API_KEY,
  VITE_STOREFRONT_URL: envVars.VITE_STOREFRONT_URL,
  VITE_AUTH_TOKEN_KEY: envVars.VITE_AUTH_TOKEN_KEY,
  VITE_PLATFORM_URL: envVars.VITE_PLATFORM_URL,
  VITE_AUTH0_CLAIMS_NAMESPACE: envVars.VITE_AUTH0_CLAIMS_NAMESPACE,
  VITE_SERVER_EVENTS_PREFIX: envVars.VITE_SERVER_EVENTS_PREFIX,
  VITE_PACKAGE_VERSION: version,
  cdn: {
    VITE_IMG_PROXY_URL: envVars.VITE_IMG_PROXY_URL,
    VITE_PROFILE_IMG_PROXY_BUCKET: envVars.VITE_PROFILE_IMG_PROXY_BUCKET,
    VITE_ARTWORK_IMG_PROXY_BUCKET: envVars.VITE_ARTWORK_IMG_PROXY_BUCKET,
    VITE_DOCUMENTS_IMG_PROXY_BUCKET: envVars.VITE_DOCUMENTS_IMG_PROXY_BUCKET,
  },
  VITE_CHECKOUT_DOMAIN: envVars.VITE_CHECKOUT_DOMAIN,
  VITE_CORS_PROXY: envVars.VITE_CORS_PROXY,
  //featureFlags
  VITE_FEATURE_EDITIONS_ENABLED: envVars.VITE_FEATURE_EDITIONS_ENABLED,
  VITE_FEATURE_HIDE_PRICE_VISIBILITY_ID: envVars.VITE_FEATURE_HIDE_PRICE_VISIBILITY_ID,
  VITE_FUTURE_FAIR_ACTIVATION_ID: envVars.VITE_FUTURE_FAIR_ACTIVATION_ID,
  VITE_FUTURE_FAIR_ACTIVATION_ID_2: envVars.VITE_FUTURE_FAIR_ACTIVATION_ID_2,
  VITE_FEATURE_DASHBOARD_ANALYTICS_ENABLED: envVars.VITE_FEATURE_DASHBOARD_ANALYTICS_ENABLED,
  filters: {
    PAGE_SIZE: 20,
    SORT_DIRECTION: 'asc',
  },
  VITE_SENTRY_INGEST_URL: envVars.VITE_SENTRY_INGEST_URL,
  VITE_FEATURE_SENTRY_ENABLED: envVars.VITE_FEATURE_SENTRY_ENABLED,
  VITE_FEATURE_SENTRY_CUSTOMER_FEEDBACK_ENABLED: envVars.VITE_FEATURE_SENTRY_CUSTOMER_FEEDBACK_ENABLED,
  VITE_AMPLITUDE_CLIENT_KEY: envVars.VITE_AMPLITUDE_CLIENT_KEY,
  VITE_USETIFUL_TOKEN: envVars.VITE_USETIFUL_TOKEN,
  VITE_USETIFUL_ENABLED: !!envVars.VITE_USETIFUL_TOKEN,
  VITE_GOOGLE_TAG_MANAGER_ID: envVars.VITE_GOOGLE_TAG_MANAGER_ID,
  VITE_CLARITY_PROJECT_ID: envVars.VITE_CLARITY_PROJECT_ID,
};

export const CREDIT_CARD_FEE_PERCENTAGE = 2.9;
export const BANK_TRANSFER_FEE_AMOUNT = 5;
export const FUTURE_FAIR_FEE_PERCENTAGE_1 = 20;
export const FUTURE_FAIR_FEE_PERCENTAGE_2 = 8;

export const QR_LABELS_PER_PAGE = {
  LISTING: 12,
  EXHIBITOR: 9,
} as const;

export const PERCENTAGE_DECIMAL_PRECISION = 4;
export const AMOUNT_DECIMAL_PRECISION = 2;

export const FIRST_LOOK_EXPORT_MAX_ROWS = 1000;
